import { jsx as _jsx } from "react/jsx-runtime";
import { createRedirect } from './redirectHandler';
import { mkRoutes } from './_';
import { adminUrls } from './urls/admin';
import { onSubdomain } from './urls/general';
import AdminPageLayout from '../../layout/admin-page-layout';
import PublicLayout from '../../layout/public-layout';
import DistrictLayout from '../../layout/page-layout';
import AdminPropertiesIndex from '../../screens/admin/properties';
import MyProperty from '../../screens/owner/parcel-property/_index';
import AdminContentHomepage from '../../screens/admin/content/homepage';
import AdminContentAbout from '../../screens/admin/content/about';
import AdminContentAnnouncements from '../../screens/admin/content/announcements/announcements';
import AdminContentAnnouncementsAddEdit from '../../screens/admin/content/announcements/add-edit';
import AdminContentEvents from '../../screens/admin/content/events';
import AdminContentEventsAddEdit from '../../screens/admin/content/events/add-edit';
import AdminContentResources from '../../screens/admin/content/resources';
import AdminContentAds from '../../screens/admin/content/ads';
import AdminContentBanners from '../../screens/admin/content/banners';
import AdminContentBranding from '../../screens/admin/content/branding';
import AdminContentTheme from '../../screens/admin/content/theme/theme';
import AdminPeople from '../../screens/admin/people';
import AdminUsersDetail from '../../screens/admin/users/detail';
import AdminGeometryEditor from '../../screens/admin/geometry-editor';
import MyPropertiesPage from '../../screens/owner/owned-properties';
import AdminModeration from '../../screens/admin/moderation';
import AdminDiscussions from '../../screens/admin/discussions';
import AdminDiscussionNew from '../../screens/admin/discussions/new';
import AdminDiscussionDetail from '../../screens/admin/discussions/detail';
import AdminTours from '../../screens/admin/tours/tours';
import AdminTourWizard from '../../screens/admin/tours/wizard/wizard';
import AdminTourInvites from '../../screens/admin/tours/tour-invites';
import AdminStories from '../../screens/admin/stories/stories';
import AdminContentMapIcons from '../../screens/admin/content/map-icons';
import AdminContentPropertyTags from '../../screens/admin/content/property-tags';
import AdminContentDiscussionKinds from '../../screens/admin/content/discussion-kinds';
import DirectorTypes from '../../screens/admin/content/director-types';
import PropertiesHub from '../../screens/admin/hubs/properties-hub';
import CommunityHub from '../../screens/admin/hubs/community-hub';
import ContentHub from '../../screens/admin/hubs/content-hub';
/** Sends the superseded Users and Invitations paths to the Members screen that replaced them. */
export const PeopleRedirect = createRedirect({
    'getRoutes': () => adminRoutesArray,
    check: () => undefined,
    fallback: ['manage', 'community', 'people'],
});
// Annotated to break the inference cycle with adminRoutesArray, which lists this route.
export const AdminRedirect = createRedirect({
    'getRoutes': () => adminRoutesArray,
    check: () => undefined,
    fallback: ['manage', 'properties'],
});
// eslint-disable-next-line react-refresh/only-export-components -- a route table beside the redirects above; route files aren't fast-refreshed
export const [adminRoutes, adminRoutesArray] = mkRoutes(adminUrls, {
    manage: AdminRedirect,
    propertiesHub: PropertiesHub,
    myProperties: () => onSubdomain
        ? DistrictLayout({ children: MyPropertiesPage({ owner: 'community' }) })
        : PublicLayout({ children: MyPropertiesPage({ owner: 'person' }) }),
    myPropertiesManage: ({ id }) => onSubdomain
        ? DistrictLayout({ children: MyProperty({ id }) })
        : PublicLayout({ children: MyProperty({ id }) }),
    myproperty: ({ id }) => onSubdomain
        ? DistrictLayout({ children: MyProperty({ id }) })
        : PublicLayout({ children: MyProperty({ id }) }),
    properties: AdminPropertiesIndex,
    geometry: AdminGeometryEditor,
    propertyTags: AdminContentPropertyTags,
    propertyTypes: AdminContentMapIcons,
    communityHub: CommunityHub,
    discussions: AdminDiscussions,
    discussionsNew: AdminDiscussionNew,
    discussionsDetail: AdminDiscussionDetail,
    contentDiscussionKinds: AdminContentDiscussionKinds,
    moderation: AdminModeration,
    tours: AdminTours,
    toursWizardNew: () => _jsx(AdminPageLayout, { children: _jsx(AdminTourWizard, {}) }),
    toursWizard: ({ id }) => _jsx(AdminPageLayout, { children: _jsx(AdminTourWizard, { id: id }) }),
    toursInvites: AdminTourInvites,
    stories: AdminStories,
    contentAnnouncements: AdminContentAnnouncements,
    contentAnnouncementsAddEdit: AdminContentAnnouncementsAddEdit,
    contentAnnouncementsEdit: AdminContentAnnouncementsAddEdit,
    contentEvents: AdminContentEvents,
    contentEventsAddEdit: AdminContentEventsAddEdit,
    contentEventsEdit: AdminContentEventsAddEdit,
    people: () => AdminPageLayout({ children: AdminPeople({}) }),
    peopleDetail: ({ id }) => _jsx(AdminPageLayout, { children: _jsx(AdminUsersDetail, { id: id }) }),
    users: PeopleRedirect,
    invitations: PeopleRedirect,
    contentHub: ContentHub,
    contentHomepage: AdminContentHomepage,
    contentAbout: AdminContentAbout,
    contentResources: AdminContentResources,
    contentBranding: AdminContentBranding,
    contentTheme: AdminContentTheme,
    contentBanners: AdminContentBanners,
    contentAds: AdminContentAds,
    directorTypes: DirectorTypes,
});
